import React from 'react';
import { useParams } from 'react-router-dom';
import BlogArticle from '../../components/Blog/BlogArticle';
import NotFound from '../NotFound';
import { getPostBySlug } from '../../content/blog';

/** Dynamic route /blogpost/:slug — renders any post from the content registry. */
const BlogPostPage = () => {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) return <NotFound />;
  return <BlogArticle post={post} />;
};

export default BlogPostPage;
